import React,{useState} from 'react';
import './addnewproduct.css';
import axios from 'axios';

function AddNewProducts() {
  const handleFileChange = (event) => {
    setPhoto(event.target.files[0]);
  };
  const [category, setCategory] = useState('');
  const [brand, setBrand] = useState('');
  const [name, setName] = useState('');
  const [isVeg, setIsVeg] = useState(true);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [mrpPrice, setMrpPrice] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [stock, setStock] = useState(0);
  const [description, setDescription] = useState('');
  const [quality, setQuality] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [photo, setPhoto] = useState(null);
  const sendData =  async (e) =>{
    try {
        e.preventDefault();
      const formData = new FormData();
      formData.append('Name', name);
      formData.append('MRP', mrpPrice);
      formData.append('Price', sellingPrice);
      formData.append('Quantity', quantity);
      formData.append('Description', description);
      formData.append('Quality', quality);
      formData.append('Brand', brand);
      formData.append('Category', category);
      formData.append('Stock',stock);
      formData.append('isVeg',isVeg);
      formData.append('isActive',isActive);
      formData.append('Img',photo);
        const response = await axios.post(process.env.REACT_APP_API_URL+'/api/Products', formData)
        console.log(response);
        console.log("hello");
    } catch (error) {
      console.error(error);
    }
  };

  const [categories, setCategories] = useState([]);
  React.useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL+'/api/Category')
        .then((response) => {
            setCategories(response.data);
        }
        )
        .catch((error) => {
            console.log(error);
        })
    }
    , [])

    const [brands, setBrands] = useState([]);
    React.useEffect(() => {
      axios.get(process.env.REACT_APP_API_URL+'/api/brands')
          .then((response) => {
              setBrands(response.data);
          }
          )
          .catch((error) => {
              console.log(error);
          })
      }
      , [])
  
  return (
    <div className=" bg-white  overflow-x-hidden ">
      <form onSubmit={sendData}>
        <h1 className="text-start text-3xl font-bold text-gray-800 mb-8">Add Product</h1>
        <div className="total">
          <div className='row1'>
        <div className=" mb-4">
  <label className="block text-gray-800 text-sm font-bold mb-2" >Category</label>
  <select className="shadow select1 "  id="category" onChange={(e)=>setCategory(e.target.value)}>
    <option>select category</option>
    {
      categories.map((category) => {
        return <option key={category.id} value={category.name}>{category.name}</option>
      })
    }
  </select>
</div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Brand</label>
          <select className="shadow select1 "  id="brand" onChange={(e)=>setBrand(e.target.value)}>
            <option>select brand</option>
            {
              brands.map((brand) => {
                return <option key={brand.id} value={brand.name}>{brand.name}</option>
              }
              )
            }
          </select>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Name</label>
          <input onChange={(e)=>setName(e.target.value)} className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="text" required />
        </div>
        </div>
        <div className='row1'>
          <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">isVeg</label>
  <select className="shadow select1 "  onChange={(e)=>setIsVeg(e.target.value)}   required>
    <option>select isVeg or not</option>
    <option value={true}>Veg</option>
    <option value={false}>Non-Veg</option> 
  </select>
  </div>
  
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Selling Price</label>
          <input  onChange={(e)=>setSellingPrice(e.target.value)}   className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="number" required />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">MRP Price</label>
          <input   onChange={(e)=>setMrpPrice(e.target.value)}   className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="number" required/>
        </div>
        </div>
        <div className='row3'>
          <div className='row31'>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Quantity</label>
          <input   onChange={(e)=>setQuantity(e.target.value)}  className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="number" required />
        </div>
        
        
        
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Stock</label>
          <input  onChange={(e)=>setStock(e.target.value)}   className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="number" required/>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Quality</label>
          <input  onChange={(e)=>setQuality(e.target.value)}   className="shadow appearance-none  input1 focus:outline-none focus:shadow-outline" type="text" required />
        </div>
        </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Description</label>
          <textarea   onChange={(e)=>setDescription(e.target.value)}  className="shadow textarea1 appearance-none  focus:outline-none focus:shadow-outline" required></textarea>
        </div>
        </div>
        <div className='row4'>
          <div>
        <label className="block text-gray-800 text-sm font-bold mb-2">isActive</label>
  <select   onChange={(e)=>setIsActive(e.target.value)}  className="shadow select1" required>
    <option value={true}>Active</option>
    <option value={false}>Disabled</option> 
  </select>
  </div>
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">Image</label>
          <input   onChange={handleFileChange}  className="shadow appearance-none img input1 focus:outline-none focus:shadow-outline" type="file" required />
        </div>
        </div>
        <div className="flex items-center justify-center">
          <button className=" button-add bg-blue-500 hover:bg-blue-700 input1 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit" >
            Submit
          </button>
        </div>
        </div>
      </form>
    </div>
  );
}

export default AddNewProducts;